$("#contact-form").on("submit", function (e) {
    e.preventDefault();
    var data = $(this).serialize();
    var pathname = window.location.pathname;
    var final = pathname.split("/", 2);
    var lang = final[1];

    if ($(this).find(".g-recaptcha").length) {
        var widget_id = $(this).find(".g-recaptcha").attr("data-tabindex");
        var responseCaptcha = grecaptcha.getResponse(widget_id);
        if (responseCaptcha.length > 0) {
            $.ajax({
                url: "/send-data",
                method: "POST",
                data: data,
                beforeSend: function () {
                    $("#contact-form input[type=submit]").prop("disabled", true);
                    $("#contact-form").css("opacity", "0.4");
                },
                success: function (data) {
                    if (data.success === false) {
                        grecaptcha.reset();
                        $(".error-captcha").html('<p style="color:red">Error en el Captcha</p>');             
                    }
                    if (data.success === true && data.reserva === true) { 
                        $("#contact-form")[0].reset()
                        grecaptcha.reset();
                        if (lang == "es") {
                            var message_success = "¡Muchas gracias por contactarnos!.<br> Te responderemos lo antes posible.";
                        } else {
                            var message_success = "Thank you very much for contacting us!.<br> We will answer you as soon as possible.";
                        }

                        Swal.fire({
                            title: (lang == 'es') ? 'Tu mensaje ha sido enviado' : 'Your message has been sent',
                            html: message_success,
                            confirmButtonColor: '#1990FF',
                            icon: "success",
                        });
                    }
                },
                error: function (data) {
                    set_errors(data.responseJSON);
                },
                complete: function () {
                    $("#contact-form").css("opacity", "1");
                    $("#contact-form input[type=submit]").prop("disabled", false);
                },
            });
    }else{
        Swal.fire({
            title: "Captcha",
            text: (lang == 'es') ? "Porfavor confirma que eres humano" : "Please ensure that you are a human",
            icon: "warning",
        });
        }
    }
});